// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the UploadFile icon.
 *
 * @component
 * @param {IconProps} props - The IconProps for the UploadFile component.
 * @returns {ReactElement} The UploadFile component.
 */
export const UploadFileIcon = (props: IconProps) => {
  const { color = '#8484A0', ...rest } = props;
  return (
    <Icon viewBox='0 0 52 53' color={color} {...rest}>
      <path
        d='M10.7048 18.8526C9.43629 17.584 9.43629 15.5264 10.7048 14.2569L23.7048 1.25686C24.3345 0.624634 25.1673 0.307251 26.0001 0.307251C26.8329 0.307251 27.6637 0.624634 28.2975 1.2594L41.2975 14.2594C42.566 15.5279 42.566 17.5856 41.2975 18.8551C40.0279 20.1236 37.9703 20.1246 36.7018 18.8552L29.2501 11.408V36.0573C29.2501 37.8519 27.7947 39.3073 26.0001 39.3073C24.2055 39.3073 22.7501 37.8519 22.7501 36.0573V11.408L15.2954 18.8526C14.0259 20.1221 11.9743 20.1221 10.7048 18.8526Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M48.75 36.0573H32.5C32.5 39.6475 29.5902 42.5573 26 42.5573C22.4098 42.5573 19.5 39.6475 19.5 36.0573H3.25C1.45539 36.0573 0 37.5126 0 39.3073V49.0573C0 50.8519 1.45539 52.3073 3.25 52.3073H48.75C50.5446 52.3073 52 50.8519 52 49.0573V39.3073C52 37.5096 50.5477 36.0573 48.75 36.0573ZM43.875 46.6198C42.5344 46.6198 41.4375 45.5229 41.4375 44.1823C41.4375 42.8416 42.5344 41.7448 43.875 41.7448C45.2156 41.7448 46.3125 42.8416 46.3125 44.1823C46.3125 45.5229 45.2156 46.6198 43.875 46.6198Z'
        fill='currentColor'
      />
    </Icon>
  );
};
